// /admin/$tab — each panel section is a real URL. Unknown tabs bounce to
// Overview. The Timeline's soul focus rides the ?soul= search param so a
// filtered footprint view is shareable between admins.

import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdminPanel } from '../components/admin/AdminPanel';
import { TAB_KEYS, type TabKey } from '../components/admin/tabs';

export const Route = createFileRoute('/admin/$tab')({
  beforeLoad: ({ params }) => {
    if (!TAB_KEYS.includes(params.tab as TabKey)) {
      throw redirect({ to: '/admin/$tab', params: { tab: 'overview' } });
    }
  },
  validateSearch: (search: Record<string, unknown>): { soul?: string } =>
    typeof search.soul === 'string' && search.soul.length > 0 ? { soul: search.soul } : {},
  component: AdminTabRoute,
});

function AdminTabRoute() {
  const { tab } = Route.useParams();
  const { soul } = Route.useSearch();
  return <AdminPanel tab={tab as TabKey} soulParam={soul ?? null} />;
}
